<!-- scoreboard.component.html -->
<div class="my-4">
  <app-user-rank [points]="$safeNavigationMigration(userScore?.points)" [rank]="$safeNavigationMigration(userScore?.rank)"></app-user-rank>
</div>
@if (scoreboard !== undefined) {
  <div class="container">
    @if (scoreboard.scores.length > 0) {
      <app-score-table [scoreboard]="scoreboard"></app-score-table>
    }
    <div class="row">
      @if (this.scoreboard !== undefined && this.scoreboard.last_key !== null) {
        <button class="btn btn-primary my-2 mx-auto" (click)="loadMore()">Zeig mir mehr</button>
      }
    </div>
    @if (scoreboard.scores.length === 0) {
      <div class="alert alert-info mt-3" role="alert">
        <h4 class="alert-heading">Wir warten auf das nächste Event dieser Kategorie!</h4>
        <p>Für diesen Bereich gibt es noch keine Auswertung. Sobald ein Tippzettel ausgewertet ist, kannst du hier die
        Rangliste einsehen.</p>
        <hr>
          <p class="mb-0">Viel Erfolg bei der nächsten Show!</p>
        </div>
      }
    </div>
  }
  @if (scoreboard == undefined) {
    <div>
      <div class="container m-4 item">
        <ngx-skeleton-loader count="5" appearance="line"/>
      </div>
    </div>
  }

